// import { useState } from "react";
// import { Link } from "react-router-dom";
// import { Layers, Rocket, Building2, GraduationCap, FlaskConical, Factory, User } from "lucide-react";

// const innovatorTypes = [
//   { id: "startup", icon: Rocket, title: "Startup", subtitle: "DPIIT recognized" },
//   { id: "msme", icon: Building2, title: "MSME", subtitle: "Small & medium" },
//   { id: "student", icon: GraduationCap, title: "Student / Faculty", subtitle: "University" },
//   { id: "researcher", icon: FlaskConical, title: "Researcher", subtitle: "R&D institution" },
//   { id: "industry", icon: Factory, title: "Industry", subtitle: "Manufacturer" },
//   { id: "innovator", icon: User, title: "Innovator", subtitle: "Individual" },
// ];

// const TOTAL_STEPS = 6;

// export default function Register() {
//   const [selectedType, setSelectedType] = useState("startup");
//   const currentStep = 1;

//   return (
//     <div className="min-h-screen bg-gray-50">
//       {/* Top bar */}
//       <header className="bg-white border-b border-gray-100">
//         <div className="max-w-6xl mx-auto flex items-center justify-between px-6 py-4">
//           <Link to="/" className="flex items-center gap-3">
//             <div className="w-9 h-9 rounded-lg bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center">
//               <Layers className="text-white w-4 h-4" />
//             </div>
//             <div>
//               <p className="font-bold text-gray-900 leading-tight">
//                 APIC <span className="text-indigo-600">ProtoHub</span>
//               </p>
//               <p className="text-[10px] tracking-wide text-gray-500 leading-tight">
//                 ANDHRA PRADESH
//               </p>
//             </div>
//           </Link>
//           <p className="text-sm text-gray-600">
//             Already have an account?{" "}
//             <Link to="/login" className="text-indigo-600 font-semibold hover:underline">
//               Sign in
//             </Link>
//           </p>
//         </div>
//       </header>

//       <main className="max-w-4xl mx-auto px-6 py-12">
//         <span className="inline-block text-xs font-semibold bg-white border border-gray-200 rounded-full px-4 py-1.5 mb-5">
//           Step {currentStep} of {TOTAL_STEPS} · Get started
//         </span>
//         <h1 className="text-3xl font-extrabold text-gray-900 mb-2">
//           Create your ProtoHub account
//         </h1>
//         <p className="text-gray-600 mb-8">
//           Choose your innovator type to personalize your workspace.
//         </p>

//         {/* Innovator type cards */}
//         <div className="grid sm:grid-cols-3 gap-4 mb-8">
//           {innovatorTypes.map(({ id, icon: Icon, title, subtitle }) => {
//             const isSelected = selectedType === id;
//             return (
//               <button
//                 key={id}
//                 type="button"
//                 onClick={() => setSelectedType(id)}
//                 className={`text-left rounded-2xl border p-5 transition ${
//                   isSelected
//                     ? "bg-gradient-to-br from-indigo-600 to-purple-600 border-transparent text-white"
//                     : "bg-white border-gray-200 text-gray-900 hover:border-indigo-300"
//                 }`}
//               >
//                 <Icon className={`w-6 h-6 mb-6 ${isSelected ? "text-white" : "text-indigo-600"}`} />
//                 <p className="font-bold">{title}</p>
//                 <p className={`text-sm ${isSelected ? "text-indigo-100" : "text-gray-500"}`}>
//                   {subtitle}
//                 </p>
//               </button>
//             );
//           })}
//         </div>

//         {/* Form card */}
//         <form className="bg-white border border-gray-100 rounded-2xl p-8">
//           <div className="grid sm:grid-cols-2 gap-6 mb-6">
//             <Field label="Full name" placeholder="Arjun Reddy" />
//             <Field label="Organization" placeholder="Ideaforge Technologies" />
//             <Field label="Email" type="email" placeholder="you@company.com" />
//             <Field label="Mobile" placeholder="+91 98xxxxxx23" />
//             <Field label="Location" placeholder="Visakhapatnam, AP" />
//             <Field label="Industry" placeholder="EV / Drones / IoT..." />
//             <Field label="GSTIN" optional placeholder="29ABCDE1234F1Z5" />
//             <Field label="DPIIT Number" optional placeholder="DIPP-XXXXX" />
//           </div>

//           <div className="mb-6">
//             <Field label="Password" type="password" placeholder="Minimum 8 characters" />
//           </div>

//           <div className="flex items-center justify-between flex-wrap gap-4">
//             <p className="text-sm text-gray-500">
//               By continuing you agree to the ProtoHub Terms.
//             </p>
//             <button
//               type="submit"
//               className="flex items-center gap-2 bg-indigo-600 hover:bg-indigo-700 text-white font-semibold px-6 py-3 rounded-xl transition"
//             >
//               Continue →
//             </button>
//           </div>
//         </form>

//         {/* Step progress bar */}
//         <div className="flex gap-2 mt-8">
//           {Array.from({ length: TOTAL_STEPS }).map((_, i) => (
//             <div
//               key={i}
//               className={`h-1.5 flex-1 rounded-full ${
//                 i < currentStep ? "bg-indigo-600" : "bg-gray-200"
//               }`}
//             />
//           ))}
//         </div>
//       </main>
//     </div>
//   );
// }

// function Field({ label, optional, ...props }) {
//   return (
//     <label className="block">
//       <span className="block text-sm font-medium text-gray-700 mb-1.5">
//         {label} {optional && <span className="text-gray-400 font-normal">(optional)</span>}
//       </span>
//       <input
//         {...props}
//         className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
//       />
//     </label>
//   );
// }



import { useState } from "react";
import { Link } from "react-router-dom";
import { Layers, Rocket, Building2, GraduationCap, FlaskConical, Factory, User, Eye, EyeOff } from "lucide-react";

const innovatorTypes = [
  { id: "startup", icon: Rocket, title: "Startup", subtitle: "DPIIT recognized" },
  { id: "msme", icon: Building2, title: "MSME", subtitle: "Small & medium" },
  { id: "student", icon: GraduationCap, title: "Student / Faculty", subtitle: "University" },
  { id: "researcher", icon: FlaskConical, title: "Researcher", subtitle: "R&D institution" },
  { id: "industry", icon: Factory, title: "Industry", subtitle: "Manufacturer" },
  { id: "innovator", icon: User, title: "Innovator", subtitle: "Individual" },
];

export default function Register() {
  const [selectedType, setSelectedType] = useState("startup");
  const [showPassword, setShowPassword] = useState(false);

  // Check if GSTIN and DPIIT should be shown
  const showBusinessFields = selectedType !== "student" &&
    selectedType !== "researcher" &&
    selectedType !== "innovator";

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Top bar */}
      <header className="bg-white border-b border-gray-100">
        <div className="max-w-7xl mx-auto flex items-center justify-between px-6 py-4">
          <Link to="/" className="flex items-center gap-3">
            <div className="w-9 h-9 rounded-lg bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center">
              <Layers className="text-white w-4 h-4" />
            </div>
            <div>
              <p className="font-bold text-gray-900 leading-tight">
                APIC <span className="text-indigo-600">ProtoHub</span>
              </p>
              <p className="text-[10px] tracking-wide text-gray-500 leading-tight">
                ANDHRA PRADESH
              </p>
            </div>
          </Link>

          <nav className="hidden md:flex items-center gap-8 text-sm font-medium text-gray-700">
            <Link to="/facilities" className="hover:text-indigo-600">Explore Facilities</Link>
            <a href="#machines" className="hover:text-indigo-600">Machines</a>
            <a href="#how-it-works" className="hover:text-indigo-600">How It Works</a>
            <Link to="/app/dashboard" className="hover:text-indigo-600">For Innovators</Link>
            <Link to="/admin" className="hover:text-indigo-600">APIC Admin</Link>
          </nav>
          <p className="text-sm text-gray-600">
            Already have an account?{" "}
            <Link to="/login" className="text-indigo-600 font-semibold hover:underline">
              Sign in
            </Link>
          </p>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-6 py-12">
        <h1 className="text-3xl font-extrabold text-gray-900 mb-2">
          Create your ProtoHub account
        </h1>
        <p className="text-gray-600 mb-8">
          Choose your innovator type to personalize your workspace.
        </p>

        {/* Innovator type cards */}
        <div className="grid sm:grid-cols-3 gap-4 mb-8">
          {innovatorTypes.map(({ id, icon: Icon, title, subtitle }) => {
            const isSelected = selectedType === id;
            return (
              <button
                key={id}
                type="button"
                onClick={() => setSelectedType(id)}
                className={`text-left rounded-2xl border p-5 transition ${isSelected
                    ? "bg-gradient-to-br from-indigo-600 to-purple-600 border-transparent text-white"
                    : "bg-white border-gray-200 text-gray-900 hover:border-indigo-300"
                  }`}
              >
                <Icon className={`w-6 h-6 mb-6 ${isSelected ? "text-white" : "text-indigo-600"}`} />
                <p className="font-bold">{title}</p>
                <p className={`text-sm ${isSelected ? "text-indigo-100" : "text-gray-500"}`}>
                  {subtitle}
                </p>
              </button>
            );
          })}
        </div>

        {/* Form card */}
        <form className="bg-white border border-gray-100 rounded-2xl p-8">
          <div className="grid sm:grid-cols-2 gap-6 mb-6">
            <Field label="Full name" placeholder="Arjun Reddy" />
            <Field label="Organization" placeholder="Ideaforge Technologies" />
            <Field label="Email" type="email" placeholder="you@company.com" />
            <Field label="Mobile" placeholder="+91 98xxxxxx23" />
            <Field label="Location" placeholder="Visakhapatnam, AP" />
            <Field label="Industry" placeholder="EV / Drones / IoT..." />

            {/* Conditionally show GSTIN and DPIIT fields */}
            {showBusinessFields && (
              <>
                <Field label="GSTIN" optional placeholder="29ABCDE1234F1Z5" />
                <Field label="DPIIT Number" optional placeholder="DIPP-XXXXX" />
              </>
            )}
          </div>

          {/* Password field with eye icon */}
          <div className="mb-6">
            <label className="block">
              <span className="block text-sm font-medium text-gray-700 mb-1.5">Password</span>
              <div className="relative">
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="Minimum 8 characters"
                  className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent pr-12"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors"
                >
                  {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                </button>
              </div>
            </label>
          </div>

          <div className="flex items-center justify-between flex-wrap gap-4">
            <p className="text-sm text-gray-500">
              By continuing you agree to the ProtoHub Terms.
            </p>
            <button
              type="submit"
              className="flex items-center gap-2 bg-indigo-600 hover:bg-indigo-700 text-white font-semibold px-6 py-3 rounded-xl transition"
            >
              Continue →
            </button>
          </div>
        </form>
      </main>
    </div>
  );
}

function Field({ label, optional, ...props }) {
  return (
    <label className="block">
      <span className="block text-sm font-medium text-gray-700 mb-1.5">
        {label} {optional && <span className="text-gray-400 font-normal">(optional)</span>}
      </span>
      <input
        {...props}
        className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
      />
    </label>
  );
}